const colors = [];
colors['light'] = '#f8f9fa';
colors['dark'] = '#343a40';
colors['success'] = '#28a745';
colors['warning'] = '#ffc107';
colors['danger'] = '#dc3545';

const durations = [2, 5, 8]; // in minutes

const techniques = [
    {
        id: 'square',
        title: 'Square Breathing',
        description: 'Aims to return breathing to its normal rhythm. This breathing exercise may help to clear the mind, relax the body, and improve focus',
        pattern: [4, 4, 4, 4] // inhale, hold, exhale, hold in seconds
    },
    {
        id: 'pursed',
        title: 'Pursed Breathing',
        description: 'Relieves shortness of breath by slowing down the breath rate',
        pattern: [4, 0, 8, 0] // inhale, hold, exhale, hold in seconds
    }
]

export { colors, durations, techniques };